import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { Box, styled } from "@mui/material";
import { Scrollbar } from "../../../../../components/Scrollbar/index.js";
import { useComputeOutOfViewportHeight } from "./useComputeOutOfViewportHeight.js";
import { useFromContentFooter } from "./useFromContentFooter.js";
const ScrollRoot = styled(Box, {
  shouldForwardProp: (prop) => prop !== "canScroll"
})(({ canScroll }) => ({
  flex: "0 1 auto",
  width: "100%",
  height: canScroll ? "100%" : void 0,
  display: "flex",
  position: "relative",
  flexDirection: "column"
}));
function FormContent(props) {
  const { header = null, footer = null, children, fixedMode, disableScroll, testId = "form-content-root" } = props;
  const { containerRef, onSizeChange, outOfViewportHeight, scrollerContentTestId } = useComputeOutOfViewportHeight();
  const { footerRef, footerMode } = useFromContentFooter(outOfViewportHeight, fixedMode);
  const canScroll = !disableScroll;
  const canScrollContent = /* @__PURE__ */ jsx(ScrollRoot, { canScroll, ref: containerRef, "data-testid": testId, "data-tidal": "form-content", children: /* @__PURE__ */ jsx(Scrollbar, { onSizeChange, children: /* @__PURE__ */ jsxs(Box, { className: "form-content-scrollbar-content", "data-testid": scrollerContentTestId, sx: { width: "100%" }, children: [
    children,
    !!footer && footerMode === "inside-scrollbar" && /* @__PURE__ */ jsx("div", { "data-testid": "footer-container", ref: footerRef, children: footer })
  ] }) }) });
  const noScrollContent = /* @__PURE__ */ jsxs(Fragment, { children: [
    children,
    !!footer && /* @__PURE__ */ jsx("div", { "data-testid": "footer-container", ref: footerRef, children: footer })
  ] });
  const content = canScroll ? canScrollContent : noScrollContent;
  const showFooter = canScroll && !!footer && footerMode === "outside-scrollbar";
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    header,
    content,
    showFooter && /* @__PURE__ */ jsx("div", { "data-testid": "footer-container", ref: footerRef, children: footer })
  ] });
}
export {
  FormContent
};
//# sourceMappingURL=FormContent.js.map
